'use strict';

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

export const Modals = {
    show(id) {
        const element = document.getElementById(id);

        if (element !== null) {
            bootstrap.Modal.getOrCreateInstance(element).show();
        }
    },

    hide(id) {
        const element = document.getElementById(id);

        if (element !== null) {
            bootstrap.Modal.getOrCreateInstance(element).hide();
        }
    },
};
